import Vue, { CreateElement, RenderContext, VNode } from 'vue';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/vue-fontawesome';

const indicatorClassName = 'wait-indicator';
const indicatorTextClassName = 'wait-indicator-text';
const indicatorBackgroundClassName = 'wait-indicator-background';

function checkValue(element: HTMLElement, value: boolean) {
    if (value) {
        element.classList.add('waiting');
    }
    else {
        element.classList.remove('waiting');
    }
}

export default Vue.directive('wait-indicator', {
    bind(element, binding, node) {
        if (!node.context) {
            return;
        }

        const waitIndicatorBackground = document.createElement('div');
        waitIndicatorBackground.classList.add(indicatorBackgroundClassName);
        element.insertBefore(waitIndicatorBackground, element.firstChild);

        const waitIndicatorDisplay = document.createElement('span');
        waitIndicatorDisplay.classList.add(indicatorClassName);

        element.insertBefore(waitIndicatorDisplay, element.firstChild);

        const waitIndicatorSpinner = document.createElement('i');
        waitIndicatorSpinner.className = 'fa fa-spinner fa-spin';
        waitIndicatorDisplay.appendChild(waitIndicatorSpinner);

        const waitIndicatorTextSpan = document.createElement('span');
        waitIndicatorTextSpan.classList.add(indicatorTextClassName);
        waitIndicatorTextSpan.textContent = 'Loading...';
        waitIndicatorDisplay.appendChild(waitIndicatorTextSpan);

        checkValue(element, binding.value as boolean);
    },
    update(el, binding) {
        checkValue(el, binding.value as boolean);
    },
    unbind(element) {
        const indicatorElements = element.getElementsByClassName(indicatorClassName);
        if (indicatorElements.length > 0) {
            const indicatorElement = indicatorElements.item(0) as Element;
            element.removeChild(indicatorElement);
        }
    }
});
